import TabTemplate from "components/shared/profile/tab";
import { featureModuleTypesEnum } from "helpers/enums";
import React from "react";
import {
    deleteSyncSystems,
    updateBidCarsPlanningSettings,
    updateChatsSettings,
    updateControlPointsSettings,
    updateCurrency,
    updateDefaultRouteOptions,
    updateExploitationSettings,
    updateFinancial,
    updateInformation,
    updateProfitabilityOfBidSettings,
    updateReportExecutionTimes,
    updateSyncSystems,
    updateWorkRestInfo,
} from "sources/profile/organization";
import BankInfo from "./bankInfo";
import BidCarsPlanningSettings from "./bidCarsPlanningSettings";
import ChatsSettings from "./chatsSettings";
import ControlPointsSettings from "./controlPointsSettings";
import CurrencySettings from "./currencySettings";
import DocumentAssignmentSettings from "./documentAssignmentSettings";
import DriverContacts from "./driverContacts";
import ExploitationSettings from "./exploitationSettings";
import FuelLimitSettings from "./fuelLimitSettings";
import PersonalInfo from "./personalInfo";
import ProfitabilityOfBidSettings from "./profitabilityOfBidSettings";
import ReportExecutionTimes from "./reportExecutionTimes";
import ReportUsers from "./reportUsers";
import RouterSettings from "./routerSettings";
import SyncSystemsSettings from "./syncSystemSettings";
import WorkRestInfo from "./workRestInfo";

export default class OrgProfileTab extends TabTemplate {
    componentDidMount() {
        const { profile, roles } = this.props;
        const { availableFeatureModules } = profile;
        const promises = [
            this.props.getOrg(),
            this.props.getReportExecutionTimes(),
            this.props.getDefaultRouteOptions(),
            this.props.getChatsSettings(),
        ];
        if (roles.isTruckingOrganizationAdmin) {
            promises.push(this.props.getSyncSystems());
        }
        if (availableFeatureModules) {
            if (availableFeatureModules.includes(featureModuleTypesEnum.PlanningCarSchedule)) {
                promises.push(this.props.getWorkRestInfo());
                promises.push(this.props.getBidCarsPlanningSettings());
            }
            if (availableFeatureModules.includes(featureModuleTypesEnum.DriverControlPoints)) {
                promises.push(this.props.getControlPointsSettings());
            }
            if (availableFeatureModules.includes(featureModuleTypesEnum.ProfitabilityOfBid)) {
                promises.push(this.props.getProfitabilityOfBidSettings());
            }
            if (availableFeatureModules.includes(featureModuleTypesEnum.Exploitation)) {
                promises.push(this.props.getExploitationSettings());
            }
        }
        Promise.all(promises).then(() => {
            this.setState({ isLoading: false });
        });
    }

    renderOrgInfo = () => {
        return null; /* (
            isManager && (
                <div className="panel">
                    <div className="field-wrap field-wrap--value field-wrap--disabled panel__row">
                        <div className="field-wrap__label">
                            <Avatar cname="panel__row-avatar" imageUrl={organization.imageUrl} />
                        </div>
                        <div className="field-wrap__input">{organization.name}</div>
                    </div>
                </div>
            )
        ); */
    };

    renderBody = () => {
        const {
            modal,
            roles,
            getOrg,
            editable,
            organization,
            workRestInfo,
            getWorkRestInfo,
            profile,
            executionTimes,
            getReportExecutionTimes,
            defaultRouteOptions,
            getDefaultRouteOptions,
            controlPointsSettings,
            getControlPointsSettings,
            syncSystems,
            getSyncSystems,
            bidCarsPlanningSettings,
            getBidCarsPlanningSettings,
            profitabilityOfBidSettings,
            getProfitabilityOfBidSettings,
            chatsSettings,
            getChatsSettings,
            exploitationSettings,
            getExploitationSettings,
            mergeBidsParams,
            bids,
            refuelingSettings,
        } = this.props;
        const { availableFeatureModules } = profile;
        return (
            <div>
                {this.renderOrgInfo()}
                <BankInfo
                    roles={roles}
                    action={updateFinancial}
                    data={organization}
                    update={getOrg}
                    editable={editable}
                    shouldUpdate={this.state.shouldUpdate}
                    updateToggle={this.updateToggle}
                />
                <PersonalInfo
                    roles={roles}
                    action={updateInformation}
                    organization={organization}
                    data={organization}
                    update={getOrg}
                    editable={editable}
                    modal={modal}
                    shouldUpdate={this.state.shouldUpdate}
                    updateToggle={this.updateToggle}
                    availableFeatureModules={availableFeatureModules}
                    mergeBidsParams={mergeBidsParams}
                    bids={bids}
                />
                <ChatsSettings
                    action={updateChatsSettings}
                    data={chatsSettings}
                    update={getChatsSettings}
                    editable={editable}
                    shouldUpdate={this.state.shouldUpdate}
                    updateToggle={this.updateToggle}
                />
                {availableFeatureModules &&
                    availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) &&
                    profile.isFuelLimitEnabled &&
                    !refuelingSettings.hideRefuelingPlanning && <FuelLimitSettings editable={editable} />}
                {availableFeatureModules && availableFeatureModules.includes(featureModuleTypesEnum.Exploitation) && (
                    <ExploitationSettings
                        action={updateExploitationSettings}
                        data={exploitationSettings}
                        update={getExploitationSettings}
                        editable={editable}
                        shouldUpdate={this.state.shouldUpdate}
                        updateToggle={this.updateToggle}
                    />
                )}
                {availableFeatureModules &&
                    availableFeatureModules.includes(featureModuleTypesEnum.PlanningCarSchedule) && (
                        <>
                            <WorkRestInfo
                                action={updateWorkRestInfo}
                                data={workRestInfo}
                                update={getWorkRestInfo}
                                editable={editable}
                                shouldUpdate={this.state.shouldUpdate}
                                updateToggle={this.updateToggle}
                            />
                            {roles.isTruckingOrganizationAdmin && (
                                <BidCarsPlanningSettings
                                    modal={modal}
                                    action={updateBidCarsPlanningSettings}
                                    data={bidCarsPlanningSettings}
                                    update={getBidCarsPlanningSettings}
                                    editable={editable}
                                    shouldUpdate={this.state.shouldUpdate}
                                    updateToggle={this.updateToggle}
                                />
                            )}
                        </>
                    )}
                {availableFeatureModules &&
                    availableFeatureModules.includes(featureModuleTypesEnum.ProfitabilityOfBid) && (
                        <ProfitabilityOfBidSettings
                            action={updateProfitabilityOfBidSettings}
                            data={profitabilityOfBidSettings}
                            update={getProfitabilityOfBidSettings}
                            editable={editable}
                            shouldUpdate={this.state.shouldUpdate}
                            updateToggle={this.updateToggle}
                        />
                    )}
                {availableFeatureModules &&
                    availableFeatureModules.includes(featureModuleTypesEnum.DriverControlPoints) && (
                        <ControlPointsSettings
                            action={updateControlPointsSettings}
                            data={controlPointsSettings}
                            update={getControlPointsSettings}
                            editable={editable}
                            shouldUpdate={this.state.shouldUpdate}
                            updateToggle={this.updateToggle}
                        />
                    )}
                <ReportExecutionTimes
                    action={updateReportExecutionTimes}
                    data={{ executionTimes }}
                    update={getReportExecutionTimes}
                    editable={editable}
                    shouldUpdate={this.state.shouldUpdate}
                    updateToggle={this.updateToggle}
                    roles={roles}
                    profile={profile}
                    organization={organization}
                    modal={modal}
                />
                {roles.isTruckingOrganizationAdmin && (
                    <SyncSystemsSettings
                        modal={modal}
                        action={updateSyncSystems}
                        data={syncSystems}
                        update={getSyncSystems}
                        delete={deleteSyncSystems}
                        editable={editable}
                        shouldUpdate={this.state.shouldUpdate}
                        updateToggle={this.updateToggle}
                    />
                )}
                <RouterSettings
                    modal={modal}
                    profile={profile}
                    action={updateDefaultRouteOptions}
                    data={defaultRouteOptions}
                    update={getDefaultRouteOptions}
                    editable={editable}
                    shouldUpdate={this.state.shouldUpdate}
                    updateToggle={this.updateToggle}
                />
                <CurrencySettings
                    action={updateCurrency}
                    data={organization}
                    update={getOrg}
                    editable={editable}
                    shouldUpdate={this.state.shouldUpdate}
                    updateToggle={this.updateToggle}
                />
                <DriverContacts editable={editable} profile={profile} />
                {availableFeatureModules &&
                    availableFeatureModules.includes(featureModuleTypesEnum.DocumentAssignment) && (
                        <DocumentAssignmentSettings editable={editable} />
                    )}
                {roles.isTruckingOrganizationAdmin && <ReportUsers editable={editable} modal={modal} />}
            </div>
        );
    };
}
